export class TransactionIdLabelTranslation {
    public dictionaryId: number;
    public field: number;
    public translatedValue: string;
}